module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"p11s3titles":[{"titleS":false,"title":"Listen to the "},{"titleS":true,"title":"opinions "},{"titleS":false,"title":"of other students about AICAD Business School"}]},"es":{"p11s3titles":[{"titleS":false,"title":"Escucha las "},{"titleS":true,"title":"opiniones "},{"titleS":false,"title":"de otros estudiantes sobre AICAD Business School"}]}}')
  delete Component.options._Ctor
}
